import styled, { css } from 'styled-components';
import { StyledContainer as Container } from '../../components/Container/container.styles';

export const StyledContainer = styled(Container)`
  align-items: center;
  display: flex;
  flex: 1;
  gap: 32px;
  justify-content: center;

  ${({ theme }) => css`
    ${theme.media.mobile} {
      align-items: center;
      flex-direction: column;
    }
  `}
`;
export const StyledImage = styled.img`
  max-width: 50%;

  ${({ theme }) => css`
    ${theme.media.mobile} {
      max-width: 100%;
    }
  `}
`;
